import { render, staticRenderFns } from "./QRCodeDownload.vue?vue&type=template&id=0f835229&scoped=true"
import script from "./QRCodeDownload.vue?vue&type=script&lang=ts"
export * from "./QRCodeDownload.vue?vue&type=script&lang=ts"
import style0 from "./QRCodeDownload.vue?vue&type=style&index=0&id=0f835229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f835229",
  null
  
)

export default component.exports